<template lang="pug">
v-dialog(v-model="dialog" width="600" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-3(small color="red" dark outlined rounded v-on="on")
            v-icon mdi-delete
            | Delete
    v-card(:loading="loading")
        v-card-title Delete Confirmation
        v-card-text Are you sure you wan't to delete this custom survey?
        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="deleteItem" :loading="loading") Delete

    v-snackbar(v-model="error.show" top color="red")
        v-icon(left) mdi-alert-circle-outline
        | {{ error.message }}
        template(v-slot:action="{ attrs }")
            v-btn(
                color="white"
                text
                v-bind="attrs"
                @click="error.show = false"
            ) Close
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        id: Number
    },
    data() {
        return {
            error: {
                show: false,
                message: null
            },
            loading: false,
            dialog: false
        };
    },
    methods: {
        async deleteItem() {
            try {
                this.loading = true;
                await this.deleteCustomSurvey(this.id);
                this.$emit('success');
                this.dialog = false;
            } catch(err) {
                this.error.message = err.message;
                this.error.show = true;
            } finally {
                this.loading = false;
            }
        },
        ...mapActions('bh-user-survey-custom', { deleteCustomSurvey: 'remove' })
    }
}
</script>